import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IPayScale } from '../../pay-scales.types';

/**
 * Handles display of dump card
 */
@Component({
	selector: 'app-pay-scale-card',
	templateUrl: './pay-scale-card.component.html'
})
export class PayScaleCardComponent implements OnInit {
	constructor(private router: Router) {}

	@Input() public payScale: IPayScale;

	public colorName: string = '#E3F2FD';
	public selectedPayScaleId: number = 0;

	public ngOnInit(): void {
		if (!this.payScale) {
			return;
		}
	}

	public isFuture(effectiveStart: string): boolean {
		return Date.parse(effectiveStart) > Date.now();
	}

	public navigate(payScaleId: number): void {
		this.router
			.navigate(['/pilotpay/pay-scales', payScaleId])
			.then(() => {
				this.selectedPayScaleId = payScaleId;
			})
			.catch((err: Error) => {
				console.error(err);
			});
	}

	public overview(payScaleId: number): void {
		this.router
			.navigate(['/pilotpay/pay-scales/overview', payScaleId])
			.then(() => {
				this.selectedPayScaleId = payScaleId;
			})
			.catch((err: Error) => {
				console.error(err);
			});
	}
}
